import React from 'react'
import { useThemeUI } from 'theme-ui'

import { ListItem as SparkListItem } from '@uswitch/spark.list'
import { path } from '../../utils/obj'

const ListItem = ({ icon, iconColor = '', children }) => {
  const { theme } = useThemeUI()
  const color = path(['colors', iconColor], theme)

  return (
    <SparkListItem icon={icon || null} iconColor={color || iconColor}>
      {children}
    </SparkListItem>
  )
}

export default ListItem
